module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/blue-grey-beard-glasses/blue-grey-beard-glasses@1x.png"